// Wraps every PM Suite page (list, project detail, template detail) so the
// left sub-rail appears alongside the same content area. The rail lives here
// instead of in the global Menu — it's scoped to the /Projects micro-app and
// doesn't affect any other top-level surface.

import { IonContent, IonPage } from '@ionic/react';

import '../../pm/theme.css';
import SubRail, { PmSection } from './SubRail';

interface Props {
  /** Which sub-rail item to highlight. */
  active: PmSection;
  /** Called when the user picks a different section. Parent owns the state
   *  and any URL syncing — the rail itself never navigates, which keeps
   *  IonRouterOutlet out of the path and prevents the intermittent
   *  blank-container bug from Ionic's page-transition logic.
   *  Optional so existing static pages (e.g. ProjectDetail) that just
   *  display the rail can omit it. */
  onSectionChange?: (id: PmSection) => void;
  /** The page body. Should NOT include the global IonPage/IonContent — those
   *  are rendered here so the rail stays in the same scrollable region.    */
  children: React.ReactNode;
}

const PmSuiteLayout: React.FC<Props> = ({ active, onSectionChange, children }) => {
  return (
    <IonPage>
      <IonContent fullscreen>
        <div className="pm-app">
          <div className="pm-suite">
            <SubRail
              active={active}
              // Default no-op for pages that don't switch sections (e.g.
              // ProjectDetail just shows the rail without responding to
              // clicks on its own — it lives at a different URL).
              onSelect={onSectionChange ?? (() => undefined)}
            />
            <main className="pm-canvas">{children}</main>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default PmSuiteLayout;
